<template>
  <div v-bind:class="{ 'table-alert': alert }">
    <input
      type="text"
      ref="input"
      name="ean"
      :class="strInputClasses"
      v-model="displayValue"
      v-validate="validation"
      :data-vv-as="label"
      @blur="isInputActive = false"
      @focus="isInputActive = true"
      @input="handleInput"
    >
    <span style="display: block; word-break: break-word" v-show="errors.has('ean') && inputDirty" class="text-danger">※{{ errors.first('ean') }}</span>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: String
    },
    validation: {
      type: String
    },
    label: {
      type: String
    },
    alert: {
      type: Boolean
    },
    inputClasses: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      isInputActive: false,
      isValidated: false,
      displayValue: this.value
    }
  },
  computed: {
    inputDirty () {
      return this.fields.ean.dirty || this.isValidated
    },
    strInputClasses () {
      let classes = 'form-control text-center'
      if (this.inputClasses) {
        classes = 'form-control ' + this.inputClasses
      }
      return classes
    }
  },
  methods: {
    handleInput () {
      this.$emit('input', this.$refs.input.value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/InputText.vue